import { useState } from "react"

import { useEvent } from "shared/lib/useEvent"

import { useTeamMemberByEmail } from "entities/team-members/model/useTeamMemberByEmail"

import { ProjectTeamPopoverProps } from "../ProjectTeamPopover"
import { ProjectTeamPopoverViewModel } from "../ui/ProjectTeamPopoverView"

export function useProjectTeamPopoverViewModel({
  onManage,
  defaultOpen = false,
  email,
  ...rest
}: ProjectTeamPopoverProps): ProjectTeamPopoverViewModel {
  const currentUserMember = useTeamMemberByEmail({
    email,
    teamMembers: rest.team?.memberships
  })
  const [open, setOpen] = useState(defaultOpen)

  const handleManage = useEvent(() => {
    if (onManage) {
      onManage()
    }

    setOpen(false)
  })

  return {
    ...rest,
    open,
    defaultOpen,
    currentUserMember,
    email,
    onOpenChange: setOpen,
    onManage: onManage ? handleManage : undefined
  }
}
